import { Star, ThumbsUp, Facebook } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";
import { Reveal } from "../Reveal";

const reviews = [
  { name: "Dumitrascu Ioana Alina", date: null, text: "Recomand cu mare drag! Seriozitate și profesionalism, mașini performante și dotate!", rating: 5 },
];

const Quote = ({ r, i, bordered = false }) => (
  <div data-testid={`testimonial-${i}`} className={`h-full flex flex-col ${bordered ? "md:border-l md:border-slate-200 md:pl-10" : ""}`}>
    <span aria-hidden="true" className="font-display font-extrabold text-6xl leading-[0.55] text-[#1565C0] select-none">„</span>
    <p className="mt-6 text-slate-800 text-lg leading-relaxed flex-1">{r.text}</p>
    <div className="mt-8 pt-5 border-t border-slate-200 flex items-center gap-3">
      <div className="grid place-items-center w-10 h-10 rounded-full bg-[#1565C0] text-white font-display font-bold text-sm shrink-0">
        {r.name.charAt(0)}
      </div>
      <div className="min-w-0">
        <div className="font-semibold text-slate-900 text-[15px] leading-tight">{r.name}</div>
        <div className="text-xs text-slate-500 flex items-center gap-1">
          {r.date && <>{r.date} · </>}
          <Facebook size={11} className="fill-[#1565C0] text-[#1565C0]" />
        </div>
      </div>
      <div className="ml-auto flex flex-col items-end gap-1.5 shrink-0">
        <span className="flex gap-0.5">
          {[...Array(r.rating)].map((_, s) => (
            <Star key={s} size={13} className="fill-[#1565C0] text-[#1565C0]" />
          ))}
        </span>
        <span className="inline-flex items-center gap-1 text-[#1565C0] text-xs font-semibold">
          <ThumbsUp size={12} className="fill-[#1565C0]" /> Recomandă
        </span>
      </div>
    </div>
  </div>
);

export const Testimonials = () => (
  <section id="testimoniale" data-testid="testimonials-section" className="py-24 lg:py-36 bg-[#F8FAFC]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <Reveal className="max-w-2xl lg:ml-[8.333%]">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#1565C0]">
          <Facebook size={16} className="fill-[#1565C0] text-[#1565C0]" /> Recenzii de pe Facebook
        </p>
        <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900">
          Experiențele celor care au învățat cu noi
        </h2>
      </Reveal>

      {reviews.length === 1 ? (
        <Reveal delay={0.1}>
          <div className="mt-14 max-w-2xl lg:ml-[16.666%]">
            <Quote r={reviews[0]} i={0} />
          </div>
        </Reveal>
      ) : (
        <Reveal delay={0.1}>
          <Carousel opts={{ align: "start", loop: true }} className="mt-14">
            <CarouselContent>
              {reviews.map((r, i) => (
                <CarouselItem key={i} className="md:basis-1/2 lg:basis-1/3">
                  <Quote r={r} i={i} bordered={i > 0} />
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="flex justify-end gap-2 mt-10">
              <CarouselPrevious data-testid="testimonial-prev" className="static translate-y-0 rounded-full border-slate-200 hover:bg-[#1565C0] hover:text-white" />
              <CarouselNext data-testid="testimonial-next" className="static translate-y-0 rounded-full border-slate-200 hover:bg-[#1565C0] hover:text-white" />
            </div>
          </Carousel>
        </Reveal>
      )}
    </div>
  </section>
);

export default Testimonials;
